import React from 'react'

// Shows the whole image whatever its shape (a portrait exercise thumbnail, say),
// with a darkened, blurred copy filling the rest of the box. Fills its parent,
// which needs `relative` and `overflow-hidden`.
export default function FittedThumb({ src, alt }) {
  return (
    <>
      <img
        src={src}
        alt=''
        aria-hidden='true'
        className='absolute inset-0 w-full h-full object-cover blur-sm scale-110'
      />
      <div className='absolute inset-0 bg-black/30' />
      <img src={src} alt={alt} className='relative w-full h-full object-contain' />
    </>
  )
}
